import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Shipment} from '../domain/shipment';
import {Session} from '../domain/session';
import {filter} from 'rxjs/operators';
import {CoreConfigurationService} from '../core-configuration.service';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css'],
    standalone: false
})
export class AdminComponent implements OnInit {
  shipments: Shipment[];
  deviatedShipments: Shipment[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private session: Session,
    public coreConfiguration: CoreConfigurationService
  ) {
  }

  ngOnInit() {
    if (this.session.getUserType() === 'WebAdmin') {
      this.initValue();

      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event) => {
          this.initValue();
        });
    }
  }

  private initValue() {
    this.shipments = this.route.snapshot.data['data'][0].shipments;
    this.deviatedShipments = this.route.snapshot.data['data'][1].shipments;
  }

  showShipment(row: Shipment) {
    this.router.navigate(['/admin/shipment', row.Number]);
  }
}
